import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";

export type Inputs = "mes" | "anio";
export type Buttons = "buscar";

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 3 }, (_, i) => currentYear - i);

const monthOptions = [
  { value: "01", label: "Enero" },
  { value: "02", label: "Febrero" },
  { value: "03", label: "Marzo" },
  { value: "04", label: "Abril" },
  { value: "05", label: "Mayo" },
  { value: "06", label: "Junio" },
  { value: "07", label: "Julio" },
  { value: "08", label: "Agosto" },
  { value: "09", label: "Septiembre" },
  { value: "10", label: "Octubre" },
  { value: "11", label: "Noviembre" },
  { value: "12", label: "Diciembre" }
];

const yearOptions = years.map(year => ({
  value: year,
  label: year
}));

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "mes",
      label: "* Mes",
      bts: { mCol: 3 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione",
        data: monthOptions
      }
    },
    {
      name: "anio",
      label: "* Año",
      bts: { mCol: 3 },
      component: ISelectBuilder,
      props: {
        emptyLabel: currentYear.toString(),
        data: yearOptions
      }
    }
  ],
  buttons: [
    {
      name: "buscar",
      label: "Buscar Empleados",
      isSubmit: true,
      bts: { mCol: 3 },
      component: IButtonBuilder
    }
  ],
  validations: {
    mes: {
      required: {
        validator: value => !value,
        message: () => "Seleccione el mes"
      }
    }
  },
  rows: [["mes", "anio", "buscar"]]
};
